// lib/utils/fileSortpref.js
const STORAGE_NS = "file_sort_pref_v1"; // 버전 포함 네임스페이스
export const FILE_SORT_PREF_EVENT = "file-sort-pref-change";

const FILE_SORT_KEYS = [
  "uploaded_at",
  "file_name",
  "is_corrupted",
  "file_type",
  "facility_type",
  "building_name",
  "floor",
  "location",
  "facility_name",
];
const SORT_DIR = { ASC: "ASC", DESC: "DESC" };

const DEFAULT_SORT = { sortKey: "uploaded_at", sortDir: SORT_DIR.DESC };

function isBrowser() {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

function keyOf(userId) {
  // userId 없으면 저장/조회 하지 않도록 null 반환
  if (!userId) return null;
  return `${STORAGE_NS}:${userId}`;
}

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function normalize(pref) {
  const sortKey = FILE_SORT_KEYS.includes(pref && pref.sortKey)
    ? pref.sortKey
    : DEFAULT_SORT.sortKey;

  const sortDir =
    (pref && pref.sortDir) === SORT_DIR.ASC ||
    (pref && pref.sortDir) === SORT_DIR.DESC
      ? pref.sortDir
      : DEFAULT_SORT.sortDir;

  return { sortKey, sortDir };
}

// ✅ 유저별 저장
export function setFileSortPref(userId, pref) {
  if (!isBrowser()) return;
  const k = keyOf(userId);
  if (!k) return;

  const normalized = normalize(pref);
  const payload = { v: 1, t: Date.now(), ...normalized };

  localStorage.setItem(k, JSON.stringify(payload));

  if (
    typeof window !== "undefined" &&
    typeof window.dispatchEvent === "function"
  ) {
    window.dispatchEvent(
      new CustomEvent(FILE_SORT_PREF_EVENT, {
        detail: {
          userId,
          sortKey: normalized.sortKey,
          sortDir: normalized.sortDir,
        },
      }),
    );
  }
}

// ✅ 유저별 조회
export function getFileSortPref(userId) {
  if (!isBrowser()) return { ...DEFAULT_SORT };
  const k = keyOf(userId);
  if (!k) return { ...DEFAULT_SORT };

  const raw = localStorage.getItem(k);
  if (!raw) return { ...DEFAULT_SORT };

  const parsed = safeParse(raw);
  if (!parsed || parsed.v !== 1) return { ...DEFAULT_SORT };

  return normalize(parsed);
}

// ✅ 유저별 삭제(선택)
export function clearFileSortPref(userId) {
  if (!isBrowser()) return;
  const k = keyOf(userId);
  if (!k) return;
  localStorage.removeItem(k);
}

export const FILE_SORT_PREF = { DEFAULT_SORT, SORT_DIR, FILE_SORT_KEYS };
